import { samePageLinkNavigation } from "@/utils/functions/samePageLinkNavigation";
import { CircularProgress, Stack, Tabs } from "@mui/material";
import Box from "@mui/material/Box";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import LinkTab from "./components/LinkTab";

const CorpusMaker = React.lazy(() => import("./tabs/CorpusMaker"));

const GRAMMAR_PAGE_PATH = `${process.env.REACT_APP_START_URL}configuration/grammar`;

const LINK_TABS = [
  {
    label: "Corpus",
    path: GRAMMAR_PAGE_PATH,
  },
];

const mapPathToComponent: Dic<() => React.ReactNode> = {
  [GRAMMAR_PAGE_PATH]: () => <CorpusMaker />,
};

const Configuration = () => {
  const navigate = useNavigate();

  const currentTabValue = LINK_TABS.findIndex((tab) => tab.path === location.pathname);

  // because mui tabs does not accept -1
  const absoluteTabValue = currentTabValue >= 0 ? currentTabValue : false;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // event.type can be equal to focus with selectionFollowsFocus.
    if (
      event.type !== "click" ||
      (event.type === "click" && samePageLinkNavigation(event as React.MouseEvent<HTMLAnchorElement, MouseEvent>))
    ) {
      const newTabValue = LINK_TABS[newValue].path;
      navigate(newTabValue);
    }
  };

  const componentToShow = React.useMemo(() => {
    if (mapPathToComponent?.[location.pathname]) return mapPathToComponent[location.pathname]();
    return null;
  }, [location.pathname]);

  return (
    <Stack width="100%" height="100%" justifyContent="start" alignItems="start" mb={2}>
      <Stack spacing={2} width="100%" height="100%">
        <Box sx={{ width: "100%", maxWidth: "100%" }}>
          {LINK_TABS.length > 1 ? (
            <Box sx={{ maxWidth: "100%" }}>
              <Tabs variant="scrollable" value={absoluteTabValue} onChange={handleChange} aria-label="settings tabs">
                {LINK_TABS.map(({ label, path }) => (
                  <LinkTab label={label} href={path} key={path} />
                ))}
              </Tabs>
            </Box>
          ) : null}
        </Box>

        <React.Suspense fallback={<CircularProgress />}>
          <Stack
            justifyContent="start"
            alignItems="start"
            sx={{ width: "100%", p: 1, boxSizing: "border-box", height: "100%", overflowY: "auto" }}>
            {componentToShow}
          </Stack>
        </React.Suspense>
      </Stack>
    </Stack>
  );
};

export default Configuration;
